/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./hidden-screen";
import * as i2 from "ionic-angular/navigation/nav-controller";
import * as i3 from "ionic-angular/navigation/nav-params";
var styles_HiddenScreenPage = [];
var RenderType_HiddenScreenPage = i0.ɵcrt({ encapsulation: 2, styles: styles_HiddenScreenPage, data: {} });
export { RenderType_HiddenScreenPage as RenderType_HiddenScreenPage };
export function View_HiddenScreenPage_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "div", [["style", "position: absolute; width: 100%; height: 100%; background-color: gray; top: 0px; left: 0px;"]], null, null, null, null, null))], null, null); }
export function View_HiddenScreenPage_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "page-hidden-screen", [], null, null, null, View_HiddenScreenPage_0, RenderType_HiddenScreenPage)), i0.ɵdid(1, 49152, null, 0, i1.HiddenScreenPage, [i2.NavController, i3.NavParams], null, null)], null, null); }
var HiddenScreenPageNgFactory = i0.ɵccf("page-hidden-screen", i1.HiddenScreenPage, View_HiddenScreenPage_Host_0, {}, {}, []);
export { HiddenScreenPageNgFactory as HiddenScreenPageNgFactory };
//# sourceMappingURL=hidden-screen.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/hidden-screen/hidden-screen.ngfactory.js
// module id = null
// module chunks = 